import {useTranslation} from 'react-i18next';

import {returnSingleNewLabel} from './commonFunctions';

// import {PermissionEnum} from '../../../../../constants/permissionsEnum';

interface PermissionsObject {
  [key: string]: PermissionsObject | Permission[];
}

interface Permission {
  value: string;
  description: string;
}

export const TranslatedTextInString: (translationKey: string) => string = (
  translationKey
) => {
  const {t} = useTranslation();

  return t(`${translationKey}`);
};

export default function getLabelsFromSelectedPermissions(
  permissionsObject: PermissionsObject,
  selectedPermissionsArray: string[] | undefined
): string[] {
  const labels: string[] = [];

  function traversePermissions(obj: PermissionsObject): void {
    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        (obj[key] as Permission[]).forEach((permission) => {
          if (selectedPermissionsArray?.includes(permission.value)) {
            labels.push(returnSingleNewLabel(permission.description, true));
          }
        });
      } else if (typeof obj[key] === 'object') {
        traversePermissions(obj[key] as PermissionsObject);
      }
    }
  }

  traversePermissions(permissionsObject);

  return labels;
}
